const tab = 'plus-websites';
const type = 'feature_clicked';

// Events exclusive to the upsell journey (no builder access)
export const WEBSITE_UPSELL_EVENTS = {
  STARTED: { action: 'website_upsell_started', type, tab },
  ONBOARDING_STARTED: { action: 'website_upsell_onboarding_started', type, tab },
  COLOUR_SAVED: { action: 'website_upsell_colour_saved', type, tab },
  LOGO_UPLOADED: { action: 'website_upsell_logo_uploaded', type, tab },
  SITE_GENERATED: { action: 'website_site_generated', type, tab },
  CHECKOUT_STARTED: { action: 'website_checkout_started', type, tab },
  CHECKOUT_COMPLETED: { action: 'website_checkout_completed', type, tab },
  DESTINATION_SAVED: { action: 'website_upsell_destination_saved', type, tab },
  DOMAIN_SAVED: { action: 'website_upsell_domain_saved', type, tab },
  COMPLETED: { action: 'website_upsell_completed', type, tab },
  BANNER_CLICKED: { action: 'website_upsell_banner_clicked', type, tab },
};

// Events for users who already have builder access
export const WEBSITE_ONBOARDING_EVENTS = {
  COLOUR_SAVED: { action: 'website_onboarding_colour_saved', type, tab },
  LOGO_UPLOADED: { action: 'website_onboarding_logo_uploaded', type, tab },
  DESTINATION_SAVED: { action: 'website_onboarding_destination_saved', type, tab },
  DOMAIN_SAVED: { action: 'website_onboarding_domain_saved', type, tab },
  COMPLETED: { action: 'website_onboarding_completed', type, tab },
};

// Events for the Web Builder guide-video modal shown on first open of Connect
export const WEBSITE_GUIDE_EVENTS = {
  PROMO_DISMISSED: { action: 'website_guide_promo_dismissed', type, tab },
  PROMO_CTA_CLICKED: { action: 'website_guide_promo_cta_clicked', type, tab },
};
